import Benchmarks from './Benchmarks';

export default Benchmarks;
